import { AppointmentResult } from "lib/api-types/schemas";
import { normalizeCardOnFile } from "@/features/payment/utils/normalizeCardOnFile";
import { CardCollectionRow } from "../types";
import { CaptureLinkState } from "@/features/card-capture/staff";

const appointmentToRowAdapter = (
  appointment: AppointmentResult,
): CardCollectionRow => ({
  time: new Date(appointment.appointmentUtc!),
  timeZone: appointment.clinicTimezone ?? null,
  patient: {
    firstName: appointment.firstName!,
    lastName: appointment.lastName!,
    middleName: appointment.middleName ?? null,
    address: appointment.address,
    practiceId: appointment.practiceId!,
    patientId: appointment.patientId!,
    dateOfBirth: appointment.dateOfBirth!,
    mrn: appointment.mrn!,
    phone: appointment.phoneNumber ?? null,
    cardCapture: appointment.cardCapture! as CaptureLinkState,
    cardOnFile: normalizeCardOnFile(appointment.cardOnFile),
  },
});

export default appointmentToRowAdapter;
